<!-- Work Log Dashboard -->
<div class="work-log-container">
  <!-- Header -->
  <div class="work-log-header">
    <div class="header-content">
      <h1 class="work-log-title">
        <mat-icon class="title-icon">assignment</mat-icon>
        Work Log Management
      </h1>
      <p class="work-log-subtitle">Track daily progress reports with descriptions and images</p>
    </div>
    <div class="header-actions">
      <button mat-raised-button color="primary" (click)="openCreateDialog()">
        <mat-icon>add</mat-icon>
        New Work Log
      </button>
      <button mat-raised-button color="accent" (click)="loadWorkLogs()">
        <mat-icon>refresh</mat-icon>
        Refresh
      </button>
    </div>
  </div>

  <!-- Statistics Cards -->
  <div class="stats-section">
    <div class="stats-header">
      <h2>Work Log Statistics</h2>
      <button mat-icon-button (click)="loadWorkLogStats()" [disabled]="loadingStats">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>

    <!-- Loading State for Stats -->
    <div class="loading-stats" *ngIf="loadingStats">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Loading statistics...</p>
    </div>

    <!-- Stats Grid -->
    <div class="stats-grid" *ngIf="!loadingStats && workLogStats">
      <div class="stat-card total">
        <div class="stat-icon">
          <mat-icon>description</mat-icon>
        </div>
        <div class="stat-content">
          <h3>Total Logs</h3>
          <p class="stat-value">{{ workLogStats.total_logs }}</p>
        </div>
      </div>

      <div class="stat-card hours">
        <div class="stat-icon">
          <mat-icon>schedule</mat-icon>
        </div>
        <div class="stat-content">
          <h3>Total Hours</h3>
          <p class="stat-value">{{ workLogStats.total_hours | number:'1.0-1' }}</p>
        </div>
      </div>

      <div class="stat-card progress">
        <div class="stat-icon">
          <mat-icon>trending_up</mat-icon>
        </div>
        <div class="stat-content">
          <h3>Avg Progress</h3>
          <p class="stat-value">{{ workLogStats.avg_progress | number:'1.0-1' }}%</p>
        </div>
      </div>

      <div class="stat-card completed">
        <div class="stat-icon">
          <mat-icon>check_circle</mat-icon>
        </div>
        <div class="stat-content">
          <h3>Completed</h3>
          <p class="stat-value">{{ workLogStats.completed_logs }}</p>
        </div>
      </div>

      <div class="stat-card in-progress">
        <div class="stat-icon">
          <mat-icon>pending</mat-icon>
        </div>
        <div class="stat-content">
          <h3>In Progress</h3>
          <p class="stat-value">{{ workLogStats.in_progress_logs }}</p>
        </div>
      </div>

      <div class="stat-card blocked">
        <div class="stat-icon">
          <mat-icon>block</mat-icon>
        </div>
        <div class="stat-content">
          <h3>Blocked</h3>
          <p class="stat-value">{{ workLogStats.blocked_logs }}</p>
        </div>
      </div>

      <div class="stat-card images">
        <div class="stat-icon">
          <mat-icon>photo_library</mat-icon>
        </div>
        <div class="stat-content">
          <h3>Images</h3>
          <p class="stat-value">{{ workLogStats.total_images }}</p>
        </div>
      </div>

      <div class="stat-card comments">
        <div class="stat-icon">
          <mat-icon>comment</mat-icon>
        </div>
        <div class="stat-content">
          <h3>Comments</h3>
          <p class="stat-value">{{ workLogStats.total_comments }}</p>
        </div>
      </div>
    </div>
  </div>
</div>

  <!-- Filters and Search -->
  <div class="filters-section">
    <div class="filters-content">
      <div class="search-box">
       <div class="flex flex-col">
        <mat-label>Search Work Logs</mat-label>
        <mat-form-field appearance="outline" class="search-field">
          
          <input matInput [(ngModel)]="searchTerm" (keyup.enter)="onSearch()" placeholder="Search by title, description, or tags...">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
        </div>
      </div>

      <div class="filter-controls">
        <div class="flex flex-col">
            <mat-label>Project</mat-label>
          
        <mat-form-field appearance="outline" class="filter-field">
          <mat-select [(ngModel)]="projectFilter" (selectionChange)="onFilterChange()">
            <mat-option value="">All Projects</mat-option>
            <mat-option *ngFor="let project of projects" [value]="project.id">{{ project.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        
        </div>
        <div class="flex flex-col">
            <mat-label>Status</mat-label>
            
            <mat-form-field appearance="outline" class="filter-field">
          <mat-select [(ngModel)]="statusFilter" (selectionChange)="onFilterChange()">
            <mat-option value="">All Status</mat-option>
            <mat-option value="in_progress">In Progress</mat-option>
            <mat-option value="completed">Completed</mat-option>
            <mat-option value="blocked">Blocked</mat-option>
            <mat-option value="on_hold">On Hold</mat-option>
          </mat-select>
        </mat-form-field>
    </div>
        <div class="flex flex-col">
            <mat-label>Priority</mat-label>
            <mat-form-field appearance="outline" class="filter-field">
          
          <mat-select [(ngModel)]="priorityFilter" (selectionChange)="onFilterChange()">
            <mat-option value="">All Priorities</mat-option>
            <mat-option value="low">Low</mat-option>
            <mat-option value="medium">Medium</mat-option>
            <mat-option value="high">High</mat-option>
            <mat-option value="critical">Critical</mat-option>
          </mat-select>
        </mat-form-field>
        </div>
        <div class="flex flex-col">
            <mat-label>Start Date</mat-label>
        <mat-form-field appearance="outline" class="filter-field">
          
          <input matInput type="date" [(ngModel)]="startDate" (change)="onFilterChange()">
        </mat-form-field>
        </div>
        <div class="flex flex-col">
            <mat-label>End Date</mat-label>
        <mat-form-field appearance="outline" class="filter-field">
          <input matInput type="date" [(ngModel)]="endDate" (change)="onFilterChange()">
        </mat-form-field>
      </div>
    </div>
  </div>

  <!-- Work Logs Table -->
  <div class="work-logs-section">
    <div class="section-header">
      <h2>Work Logs</h2>
      <div class="section-actions">
        <button mat-stroked-button (click)="loadWorkLogs()">
          <mat-icon>refresh</mat-icon>
          Refresh
        </button>
      </div>
    </div>

    <!-- Loading State -->
    <div class="loading-state" *ngIf="loadingLogs">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Loading work logs...</p>
    </div>

    <!-- Work Logs Table -->
    <div class="work-logs-table" *ngIf="!loadingLogs">
      <table mat-table [dataSource]="workLogs" class="mat-elevation-z1">
        <!-- Project Column -->
        <ng-container matColumnDef="project">
          <th mat-header-cell *matHeaderCellDef>Project</th>
          <td mat-cell *matCellDef="let log">
            <div class="project-info">
              <h4>{{ log.project_name }}</h4>
              <p>{{ log.project_description }}</p>
            </div>
          </td>
        </ng-container>

        <!-- Title Column -->
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef>Title</th>
          <td mat-cell *matCellDef="let log">
            <div class="title-info">
              <h4>{{ log.title }}</h4>
              <p>{{ log.description | slice:0:100 }}{{ log.description.length > 100 ? '...' : '' }}</p>
            </div>
          </td>
        </ng-container>

        <!-- User Column -->
        <ng-container matColumnDef="user">
          <th mat-header-cell *matHeaderCellDef>User</th>
          <td mat-cell *matCellDef="let log">
            <div class="user-info">
              <mat-icon class="user-icon">person</mat-icon>
              <span>{{ log.user_name }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Date Column -->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Date</th>
          <td mat-cell *matCellDef="let log">
            {{ formatDate(log.log_date) }}
          </td>
        </ng-container>

        <!-- Hours Column -->
        <ng-container matColumnDef="hours">
          <th mat-header-cell *matHeaderCellDef>Hours</th>
          <td mat-cell *matCellDef="let log">
            {{ log.hours_worked }}h
          </td>
        </ng-container>

        <!-- Progress Column -->
        <ng-container matColumnDef="progress">
          <th mat-header-cell *matHeaderCellDef>Progress</th>
          <td mat-cell *matCellDef="let log">
            <div class="progress-info">
              <span class="progress-text">{{ log.progress_percentage }}%</span>
              <mat-progress-bar 
                mode="determinate" 
                [value]="log.progress_percentage"
                [ngClass]="getProgressClass(log.progress_percentage)">
              </mat-progress-bar>
            </div>
          </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let log">
            <div class="status-badge" [ngClass]="getStatusClass(log.status)">
              <mat-icon>{{ getStatusIcon(log.status) }}</mat-icon>
              <span>{{ getStatusText(log.status) }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Priority Column -->
        <ng-container matColumnDef="priority">
          <th mat-header-cell *matHeaderCellDef>Priority</th>
          <td mat-cell *matCellDef="let log">
            <div class="priority-badge" [ngClass]="getPriorityClass(log.priority)">
              <mat-icon>{{ getPriorityIcon(log.priority) }}</mat-icon>
              <span>{{ getPriorityText(log.priority) }}</span>
            </div>
          </td>
        </ng-container>

        <!-- Media Column -->
        <ng-container matColumnDef="media">
          <th mat-header-cell *matHeaderCellDef>Media</th>
          <td mat-cell *matCellDef="let log">
            <div class="media-info">
              <span *ngIf="log.image_count > 0" class="media-count">
                <mat-icon>photo</mat-icon>
                {{ log.image_count }}
              </span>
              <span *ngIf="log.comment_count > 0" class="media-count">
                <mat-icon>comment</mat-icon>
                {{ log.comment_count }}
              </span>
            </div>
          </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let log">
            <div class="action-buttons">
              <button mat-icon-button color="primary" 
                      (click)="openViewDialog(log)"
                      matTooltip="View Details">
                <mat-icon>visibility</mat-icon>
              </button>

              <button mat-icon-button color="accent" 
                      (click)="openEditDialog(log)"
                      matTooltip="Edit Work Log">
                <mat-icon>edit</mat-icon>
              </button>

              <button mat-icon-button color="warn" 
                      (click)="deleteWorkLog(log)"
                      matTooltip="Delete Work Log">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['project', 'title', 'user', 'date', 'hours', 'progress', 'status', 'priority', 'media', 'actions']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['project', 'title', 'user', 'date', 'hours', 'progress', 'status', 'priority', 'media', 'actions'];"></tr>
      </table>

      <!-- Empty State -->
      <div class="empty-state" *ngIf="workLogs.length === 0">
        <mat-icon class="empty-icon">assignment</mat-icon>
        <h3>No work logs found</h3>
        <p>There are no work logs matching your current filters.</p>
        <button mat-raised-button color="primary" (click)="openCreateDialog()">
          <mat-icon>add</mat-icon>
          Create New Work Log
        </button>
      </div>
    </div>

    <!-- Pagination -->
    <div class="pagination-section" *ngIf="totalPages > 1">
      <mat-paginator 
        [length]="totalItems"
        [pageSize]="itemsPerPage"
        [pageIndex]="currentPage - 1"
        [pageSizeOptions]="[5, 10, 25, 50]"
        (page)="onPageChange($event)">
      </mat-paginator>
    </div>
  </div>
</div>

<!-- Create Work Log Dialog -->
<div class="dialog-overlay" *ngIf="showCreateDialog" (click)="closeCreateDialog()">
  <div class="dialog-content" (click)="$event.stopPropagation()">
    <div class="dialog-header">
      <h2>Create New Work Log</h2>
      <button mat-icon-button (click)="closeCreateDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="dialog-body">
      <form [formGroup]="workLogForm" class="work-log-form">
        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Project</mat-label>
            <mat-select formControlName="projectId" required>
              <mat-option *ngFor="let project of projects" [value]="project.id">{{ project.name }}</mat-option>
            </mat-select>
            <mat-error *ngIf="workLogForm.get('projectId')?.hasError('required')">Project is required</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Log Date</mat-label>
            <input matInput type="date" formControlName="logDate" required>
            <mat-error *ngIf="workLogForm.get('logDate')?.hasError('required')">Log date is required</mat-error>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Title</mat-label>
            <input matInput formControlName="title" required placeholder="Enter work log title">
            <mat-error *ngIf="workLogForm.get('title')?.hasError('required')">Title is required</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Status</mat-label>
            <mat-select formControlName="status" required>
              <mat-option value="in_progress">In Progress</mat-option>
              <mat-option value="completed">Completed</mat-option>
              <mat-option value="blocked">Blocked</mat-option>
              <mat-option value="on_hold">On Hold</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Hours Worked</mat-label>
            <input matInput type="number" formControlName="hoursWorked" min="0" max="24" step="0.5">
            <mat-error *ngIf="workLogForm.get('hoursWorked')?.hasError('min')">Hours cannot be negative</mat-error>
            <mat-error *ngIf="workLogForm.get('hoursWorked')?.hasError('max')">Hours cannot exceed 24</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Progress Percentage</mat-label>
            <input matInput type="number" formControlName="progressPercentage" min="0" max="100">
            <mat-error *ngIf="workLogForm.get('progressPercentage')?.hasError('min')">Progress cannot be negative</mat-error>
            <mat-error *ngIf="workLogForm.get('progressPercentage')?.hasError('max')">Progress cannot exceed 100%</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Priority</mat-label>
            <mat-select formControlName="priority" required>
              <mat-option value="low">Low</mat-option>
              <mat-option value="medium">Medium</mat-option>
              <mat-option value="high">High</mat-option>
              <mat-option value="critical">Critical</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Description</mat-label>
          <textarea matInput formControlName="description" rows="4" required 
                    placeholder="Describe the work completed today..."></textarea>
          <mat-error *ngIf="workLogForm.get('description')?.hasError('required')">Description is required</mat-error>
        </mat-form-field>

        <!-- Attachments -->
        <div class="attachments-section">
          <h4>Attachments</h4>
          <div class="attachment-actions">
            <button mat-stroked-button type="button" (click)="openCreateCameraCapture()" [disabled]="capturingGeo">
              <mat-icon>photo_camera</mat-icon>
              {{ capturingGeo ? 'Getting GPS…' : 'Camera + GPS' }}
            </button>
            <button mat-stroked-button type="button" (click)="openCreateGalleryPicker()">
              <mat-icon>photo_library</mat-icon>
              Gallery
            </button>
          </div>
          <input #cameraInput type="file" accept="image/*" capture="environment" hidden
                 (change)="onCreateCameraSelected($event)">
          <input #fileInput type="file" multiple accept="image/*" hidden
                 (change)="onCreateGallerySelected($event)">
          <div class="create-previews" *ngIf="createAttachments.length > 0">
            <div class="create-preview-item" *ngFor="let item of createAttachments; let i = index">
              <img [src]="item.preview" [alt]="item.file.name">
              <span class="geo-tag" *ngIf="item.latitude != null">
                <mat-icon>my_location</mat-icon>
                {{ formatCoords(item.latitude, item.longitude) }}
              </span>
              <button mat-icon-button type="button" color="warn" (click)="removeCreateAttachment(i)">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
        </div>

        <!-- Tags Section -->
        <div class="tags-section">
          <h4>Tags</h4>
          <div formArrayName="tags" class="tags-container">
            <div *ngFor="let tag of tagsArray.controls; let i = index" class="tag-input">
              <mat-form-field appearance="outline">
                <input matInput [formControlName]="i" placeholder="Enter tag">
              </mat-form-field>
              <button mat-icon-button color="warn" (click)="removeTag(i)" type="button">
                <mat-icon>remove_circle</mat-icon>
              </button>
            </div>
          </div>
          <button mat-stroked-button type="button" (click)="addTag()">
            <mat-icon>add</mat-icon>
            Add Tag
          </button>
        </div>

        <!-- Construction-specific fields -->
        <div class="construction-fields">
          <h4>Construction Details</h4>
          <div class="form-row">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Weather Conditions</mat-label>
              <input matInput formControlName="weatherConditions" placeholder="e.g., Sunny, Rainy, Cloudy">
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Materials Used</mat-label>
              <input matInput formControlName="materialsUsed" placeholder="List materials used">
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Equipment Used</mat-label>
              <input matInput formControlName="equipmentUsed" placeholder="List equipment used">
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Subcontractors Involved</mat-label>
              <input matInput formControlName="subcontractorsInvolved" placeholder="List subcontractors">
            </mat-form-field>
          </div>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Site Conditions</mat-label>
            <textarea matInput formControlName="siteConditions" rows="3" 
                      placeholder="Describe current site conditions..."></textarea>
          </mat-form-field>
        </div>

        <!-- Planning and Issues -->
        <div class="planning-section">
          <h4>Planning & Issues</h4>
          <div class="form-row">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Challenges Faced</mat-label>
              <textarea matInput formControlName="challengesFaced" rows="3" 
                        placeholder="Describe any challenges encountered..."></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Solutions Implemented</mat-label>
              <textarea matInput formControlName="solutionsImplemented" rows="3" 
                        placeholder="Describe solutions applied..."></textarea>
            </mat-form-field>
          </div>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Next Day Plan</mat-label>
            <textarea matInput formControlName="nextDayPlan" rows="3" 
                      placeholder="Plan for tomorrow's work..."></textarea>
          </mat-form-field>

          <div class="form-row">
            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Safety Incidents</mat-label>
              <textarea matInput formControlName="safetyIncidents" rows="3" 
                        placeholder="Report any safety incidents..."></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-field">
              <mat-label>Quality Issues</mat-label>
              <textarea matInput formControlName="qualityIssues" rows="3" 
                        placeholder="Report any quality issues..."></textarea>
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>

    <div class="dialog-actions">
      <button mat-button (click)="closeCreateDialog()">Cancel</button>
      <button mat-raised-button color="primary" 
              [disabled]="!workLogForm.valid"
              (click)="createWorkLog()">
        Create Work Log
      </button>
    </div>
  </div>
</div>

<!-- Edit Work Log Dialog -->
<div class="dialog-overlay" *ngIf="showEditDialog" (click)="closeEditDialog()">
  <div class="dialog-content" (click)="$event.stopPropagation()">
    <div class="dialog-header">
      <h2>Edit Work Log</h2>
      <button mat-icon-button (click)="closeEditDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="dialog-body">
      <form [formGroup]="workLogForm" class="work-log-form">
        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Title</mat-label>
            <input matInput formControlName="title" required>
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Status</mat-label>
            <mat-select formControlName="status" required>
              <mat-option value="in_progress">In Progress</mat-option>
              <mat-option value="completed">Completed</mat-option>
              <mat-option value="blocked">Blocked</mat-option>
              <mat-option value="on_hold">On Hold</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="form-row">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Hours Worked</mat-label>
            <input matInput type="number" formControlName="hoursWorked" min="0" max="24" step="0.5">
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Progress %</mat-label>
            <input matInput type="number" formControlName="progressPercentage" min="0" max="100">
          </mat-form-field>
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Priority</mat-label>
            <mat-select formControlName="priority" required>
              <mat-option value="low">Low</mat-option>
              <mat-option value="medium">Medium</mat-option>
              <mat-option value="high">High</mat-option>
              <mat-option value="critical">Critical</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Description</mat-label>
          <textarea matInput formControlName="description" rows="4" required></textarea>
        </mat-form-field>
      </form>
    </div>

    <div class="dialog-actions">
      <button mat-button (click)="closeEditDialog()">Cancel</button>
      <button mat-raised-button color="primary" 
              [disabled]="!workLogForm.valid"
              (click)="updateWorkLog()">
        Update Work Log
      </button>
    </div>
  </div>
</div>

<!-- View Work Log Dialog -->
<div class="dialog-overlay" *ngIf="showViewDialog" (click)="closeViewDialog()">
  <div class="dialog-content large" (click)="$event.stopPropagation()">
    <div class="dialog-header">
      <h2>Work Log Details</h2>
      <button mat-icon-button (click)="closeViewDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="dialog-body" *ngIf="selectedWorkLog">
      <div class="work-log-details">
        <div class="detail-header">
          <h3>{{ selectedWorkLog.title }}</h3>
          <div class="detail-meta">
            <span class="project-name">{{ selectedWorkLog.project_name }}</span>
            <span class="date">{{ formatDate(selectedWorkLog.log_date) }}</span>
            <span class="user">{{ selectedWorkLog.user_name }}</span>
          </div>
          <div class="detail-badges">
            <div class="status-badge" [ngClass]="getStatusClass(selectedWorkLog.status)">
              <mat-icon>{{ getStatusIcon(selectedWorkLog.status) }}</mat-icon>
              <span>{{ getStatusText(selectedWorkLog.status) }}</span>
            </div>
            <div class="priority-badge" [ngClass]="getPriorityClass(selectedWorkLog.priority)">
              <mat-icon>{{ getPriorityIcon(selectedWorkLog.priority) }}</mat-icon>
              <span>{{ getPriorityText(selectedWorkLog.priority) }}</span>
            </div>
          </div>
        </div>

        <div class="detail-content">
          <div class="detail-section">
            <h4>Description</h4>
            <p>{{ selectedWorkLog.description }}</p>
          </div>

          <div class="detail-section">
            <h4>Work Summary</h4>
            <div class="summary-grid">
              <div class="summary-item">
                <span class="label">Hours Worked:</span>
                <span class="value">{{ selectedWorkLog.hours_worked }}h</span>
              </div>
              <div class="summary-item">
                <span class="label">Progress:</span>
                <span class="value">{{ selectedWorkLog.progress_percentage }}%</span>
              </div>
            </div>
          </div>

          <!-- Tags -->
          <div class="detail-section" *ngIf="selectedWorkLog.tags && selectedWorkLog.tags.length > 0">
            <h4>Tags</h4>
            <div class="tags-display">
              <span class="tag" *ngFor="let tag of selectedWorkLog.tags">{{ tag }}</span>
            </div>
          </div>

          <!-- Construction Details -->
          <div class="detail-section" *ngIf="selectedWorkLog.weather_conditions || selectedWorkLog.materials_used">
            <h4>Construction Details</h4>
            <div class="construction-details">
              <div class="detail-item" *ngIf="selectedWorkLog.weather_conditions">
                <span class="label">Weather:</span>
                <span class="value">{{ selectedWorkLog.weather_conditions }}</span>
              </div>
              <div class="detail-item" *ngIf="selectedWorkLog.materials_used">
                <span class="label">Materials:</span>
                <span class="value">{{ selectedWorkLog.materials_used }}</span>
              </div>
              <div class="detail-item" *ngIf="selectedWorkLog.equipment_used">
                <span class="label">Equipment:</span>
                <span class="value">{{ selectedWorkLog.equipment_used }}</span>
              </div>
              <div class="detail-item" *ngIf="selectedWorkLog.subcontractors_involved">
                <span class="label">Subcontractors:</span>
                <span class="value">{{ selectedWorkLog.subcontractors_involved }}</span>
              </div>
            </div>
          </div>

          <!-- Images -->
          <div class="detail-section" *ngIf="selectedWorkLog.images && selectedWorkLog.images.length > 0">
            <h4>Images ({{ selectedWorkLog.images.length }})</h4>
            <div class="images-gallery">
              <div class="image-item" *ngFor="let image of selectedWorkLog.images">
                <img [src]="imageUrl(image.image_url)" [alt]="image.image_name" (click)="showImageDialog = true">
                <div class="image-info">
                  <span class="image-name">{{ image.image_name }}</span>
                  <span class="image-size">{{ formatFileSize(image.file_size) }}</span>
                  <span class="image-geo" *ngIf="image.latitude != null && image.longitude != null">
                    <mat-icon>my_location</mat-icon>
                    {{ formatCoords(image.latitude, image.longitude) }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Comments -->
          <div class="detail-section">
            <h4>Comments ({{ selectedWorkLog.comments?.length || 0 }})</h4>
            <div class="comments-section">
              <div class="comment-list" *ngIf="selectedWorkLog.comments && selectedWorkLog.comments.length > 0">
                <div class="comment-item" *ngFor="let comment of selectedWorkLog.comments">
                  <div class="comment-header">
                    <span class="comment-author">{{ comment.user_name }}</span>
                    <span class="comment-date">{{ formatDateTime(comment.created_at) }}</span>
                  </div>
                  <p class="comment-text">{{ comment.comment }}</p>
                </div>
              </div>
              
              <form [formGroup]="commentForm" class="comment-form">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Add Comment</mat-label>
                  <textarea matInput formControlName="comment" rows="3" 
                            placeholder="Add your comment..."></textarea>
                </mat-form-field>
                <button mat-raised-button color="primary" 
                        [disabled]="!commentForm.valid"
                        (click)="addComment(selectedWorkLog.id)">
                  Add Comment
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dialog-actions">
      <button mat-button (click)="closeViewDialog()">Close</button>
      <button mat-stroked-button color="accent" (click)="showImageDialog = true">
        Upload Images
      </button>
      <button mat-raised-button color="accent" (click)="openEditDialog(selectedWorkLog); closeViewDialog()">
        Edit Work Log
      </button>
    </div>
  </div>
</div>

<!-- Image Upload Dialog -->
<div class="dialog-overlay" *ngIf="showImageDialog" (click)="closeImageDialog()">
  <div class="dialog-content" (click)="$event.stopPropagation()">
    <div class="dialog-header">
      <h2>Upload Images</h2>
      <button mat-icon-button (click)="closeImageDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="dialog-body">
      <div class="upload-section">
        <input #fileInput type="file" multiple accept="image/*" 
               (change)="onFileSelected($event)" style="display: none;">
        
        <div class="upload-area" (click)="fileInput.click()">
          <mat-icon class="upload-icon">cloud_upload</mat-icon>
          <p>Click to select images or drag and drop</p>
          <p class="upload-hint">Supports: JPG, PNG, GIF (Max 10MB each)</p>
        </div>

        <div class="selected-files" *ngIf="selectedFiles.length > 0">
          <h4>Selected Files ({{ selectedFiles.length }})</h4>
          <div class="file-list">
            <div class="file-item" *ngFor="let file of selectedFiles; let i = index">
              <img *ngIf="imagePreviewUrls[i]" [src]="imagePreviewUrls[i]" class="file-preview">
              <div class="file-info">
                <span class="file-name">{{ file.name }}</span>
                <span class="file-size">{{ formatFileSize(file.size) }}</span>
              </div>
              <button mat-icon-button color="warn" (click)="clearFileSelection()">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dialog-actions">
      <button mat-button (click)="closeImageDialog()">Cancel</button>
      <button mat-raised-button color="primary" 
              [disabled]="selectedFiles.length === 0 || uploadingImages"
              (click)="uploadImages(selectedWorkLog?.id || 0)">
        <mat-spinner diameter="20" *ngIf="uploadingImages"></mat-spinner>
        <span *ngIf="!uploadingImages">Upload Images</span>
      </button>
    </div>
  </div>
</div>
